import React from "react";
import { Row, Col, Divider } from "antd";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import styles from "./ShoppingCart.module.scss";
import { CartCostDetails } from "../../../types/GroceryTypes";
import dividerStyles from "../../Shared/Styles/DividerStyles.module.scss";

type Props = {
  shoppingCartCostDetails: CartCostDetails;
};

function GroceryCartCostDetails({ shoppingCartCostDetails }: Props) {
  return (
    <>
      <Row className={styles.cartCostDetailsHeading}>Total</Row>
      <Row className={styles.marginDown4}>
        <Col span={16} className={textStyles.boldText14}>
          Subtotal ({shoppingCartCostDetails.totalQuantity} items) **
        </Col>
        <Col span={1} />
        <Col
          span={7}
          className={`${styles.alignTextRight} ${textStyles.normalText14} ${styles.strikeInformation}`}
        >
          ${shoppingCartCostDetails.subTotal.toFixed(2)}
        </Col>
      </Row>
      <Row className={styles.cartCostLineItems}>
        <Col span={18}>Service Fee (+ applicable taxes)</Col>
        <Col span={1} />
        <Col span={5} className={styles.alignTextRight}>
          ${shoppingCartCostDetails.serviceFee.toFixed(2)}
        </Col>
      </Row>
      <Row className={styles.cartCostLineItems}>
        <Col span={14}>Tip</Col>
        <Col span={5} className={styles.alignTextRight}>
          {shoppingCartCostDetails.tip}%
        </Col>
        <Col span={5} className={styles.alignTextRight}>
          ${shoppingCartCostDetails.tipAmount.toFixed(2)}
        </Col>
      </Row>
      <Divider className={dividerStyles.solidFadedDividerMargin8} />
      {shoppingCartCostDetails.wandaPlanName === "Plus" && (
        <Row>
          <Col span={18} className={styles.cartCostLineItems}>
            Wanda Plus Discount
          </Col>
          <Col span={1} />
          <Col span={5} className={styles.cartCostOfferDetails}>
            -${shoppingCartCostDetails.wandaPlusDiscount.toFixed(2)}
          </Col>
        </Row>
      )}
      <Row>
        <Col span={18} className={styles.cartCostLineItems}>
          Delivery
        </Col>
        <Col span={1} />
        {shoppingCartCostDetails.deliveryFee === 0 ? (
          <Col span={5} className={styles.cartCostOfferDetails}>
            FREE
          </Col>
        ) : (
          <Col
            span={5}
            className={`${styles.cartCostLineItems} ${styles.alignTextRight}`}
          >
            ${shoppingCartCostDetails.deliveryFee.toFixed(2)}
          </Col>
        )}
      </Row>
      <Row className={styles.freeDeliveryInfo}>
        Free delivery for orders above $
        {shoppingCartCostDetails.freeDeliveryLimitAmount}
      </Row>
      <Divider className={dividerStyles.solidFadedDividerMargin8} />
      <Row>
        <Col span={10} className={textStyles.normalText16}>
          Estimated total
        </Col>
        <Col span={1} />
        <Col
          span={13}
          className={`${textStyles.boldText16} ${styles.alignTextRight}`}
        >
          ${shoppingCartCostDetails.estimatedTotal.toFixed(2)}
        </Col>
      </Row>
    </>
  );
}

export default GroceryCartCostDetails;
